import React, { createContext, PropsWithChildren, useCallback, useContext, useMemo, useState } from 'react';
import {PlanCache, Profile, SignupContextType} from "../@types/signup";
import {Cart, CartProduct} from "../@types/cart";
import {deleteAddress} from "../services/localStorage.service";

const SignupContext = createContext<SignupContextType>(
  {} as any as SignupContextType,
);

export function SignupProvider(props: PropsWithChildren<unknown>) {

  const [cart, setCart] = useState<Cart | null>(null);
  const [products, setProducts] = useState<CartProduct[] | null>(null);
  const [plans, setPlans] = useState<PlanCache | null>(null);
  const [profile, setProfile] = useState<Profile | null>(null);

  const [isProvisioning, setIsProvisioning] = useState<boolean>(false);
  const [isLoadingSysInfo, setIsLoadingSysInfo] = useState<boolean>(false);

  const clearContext = useCallback(() => {
    setCart(null);
    setProducts(null);
    setPlans(null);
    setProfile(null);
    deleteAddress();
  },[]);

  const persistPlans = useCallback((value: PlanCache) => {
    setPlans(value);
  },[]);

  const persistCart = useCallback((value: Cart | null) => {
    setCart(value);
  },[]);

  const persistProducts = useCallback((value: CartProduct[] | null) => {
    setProducts(value);
  },[]);

  const persistProfile = useCallback((value: Profile) => {
    setProfile(value);
  },[]);

  const value = useMemo<SignupContextType>(
    () => ({
      isLoadingSysInfo,
      isProvisioning,
      persistPlans,
      persistCart,
      persistProducts,
      persistProfile,
      cartItems: cart,
      productItems: products,
      cachedPlans: plans,
      profile,
      clearContext,
    }),
    [isLoadingSysInfo, isProvisioning, persistPlans, persistCart, persistProducts, persistProfile, cart, products, plans, profile, clearContext]
  );

  return (
    <SignupContext.Provider value={value}>
      {props.children}
    </SignupContext.Provider>
  );
}

const useSignupContext = () => useContext(SignupContext);
export default useSignupContext;
